import { ComponentFactoryResolver, Injectable, Type, } from '@angular/core';
import { DialogService, DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { IEcaDialogRef } from '../../shared/models/eca-dialog-ref.interface';

@Injectable({
  providedIn: 'root'
})

export class EcaDynamicModalService {
  dialogRef: DynamicDialogRef | undefined;

  constructor(private resolver: ComponentFactoryResolver, private dialogService: DialogService) {
  }

  openDialog(componentType: Type<any>, config: DynamicDialogConfig): IEcaDialogRef {
    const dynamicDialogRef = this.dialogService.open(componentType, config);
    const content = this.getDialogComponentInstance(dynamicDialogRef, componentType, config);
    return { dynamicDialogRef, content } as IEcaDialogRef;
  }

  getDialogComponentInstance<T>(dynamicDialogRef: DynamicDialogRef, componentType: Type<any>, config: DynamicDialogConfig) {
    let dialogComponentComponentRef = this.dialogService.dialogComponentRefMap.get(dynamicDialogRef);
    dialogComponentComponentRef?.changeDetectorRef.detectChanges();
    let instance = dialogComponentComponentRef?.instance.componentRef.instance as any;

    if (config.data) {
      let viewContainerRef = dialogComponentComponentRef!.instance.insertionPoint.viewContainerRef;
      viewContainerRef.clear();

      let componentFactory = this.resolver.resolveComponentFactory(componentType);
      let componentRef = viewContainerRef.createComponent(componentFactory);


      for (const key in config.data) {
        componentRef.instance[key] = config.data[key];
      }
      instance = componentRef.instance;
      dialogComponentComponentRef?.changeDetectorRef.detectChanges();
    }
    return instance;
  }
}
